<template>
  <div class="wrapper view-page">
    <div class="background-image accent"
         :class="{'clear': !organization.darkMode,
         'no-gradient': !gradient}"
         :style="cssProps"></div>
    <main role="main" class="sessions-main">
      <div v-if="!headerCollapsed"
        class="session-header-big d-flex justify-content-between position-absolute w-100">
        <div class="d-flex flex-row align-items-center">
          <router-link :to="{name: 'Homepage'}" class="back-button bg-primary rounded-right">
            <inline-svg
              width="25" height="25"
              :src="require('../assets/images/icons/Icon_DropdownArrow_Down.svg')"/>
          </router-link>
          <div class="d-flex display-h6 ml-3">
            <div v-if="currentSession.resource_count > 0"
                 @click="loadResources"
                 class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Folder.svg')"/>
                          </span>
              <span class="btn-text mx-2"
                    :data-sessionid="currentSession.id">
                            {{ $t("app.label.resource") }}
                          </span>
              <span class="forum-notification font-weight-bold"
                    :class="{'active': resources.totalUnViewedResources > 0}">
                      {{ resources.totalUnViewedResources }}</span>
            </div>
            <div v-if="currentSession.badge_count > 0"
                 @click="loadBadges"
                 class="d-flex align-items-center btn-session-action
                             font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Badges.svg')"/>
                          </span>
              <span class="btn-text mx-2">
                             {{ $t("app.label.badges") }} <span class="font-weight-bold mr-2">
                            {{ currentSession.activated_badge }}/{{ currentSession.badge_count }}
                            </span>
                          </span>
            </div>
            <div v-if="currentSession.has_leaderboard == 1"
                 @click="loadLeaderboards"
                 class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Leaderboard.svg')"/>
                          </span>
              <span class="btn-text mx-2">
                            {{ $t("app.label.leaderboard") }}
                    </span>
            </div>
            <div v-if="currentSession.forum != null"
                 @click="loadForum"
                 class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Topic.svg')"/>
                          </span>
              <span class="btn-text mx-2">
                              {{ $t("app.label.forum") }}
                      </span>
              <span class="forum-notification font-weight-bold"
                    :class="{'active': forum.unreadedPostCount > 0}">
                      {{ forum.unreadedPostCount }}</span>
            </div>
            <div v-if="currentSession.user_can_view_stats"
                 @click="loadStats($event,'all')"
                 class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Score.svg')"/>
                          </span>
              <span class="btn-text mx-2">
                            {{ $t("app.label.stats") }}
                    </span>
            </div>
            <div @click="getHelp"
                 class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm">
                          <span class="icon font-weight-bold px-2" style="font-size: 1.3rem ">
                            ?
                          </span>
              <span class="btn-text mx-2">
                            {{ $t("app.label.help") }}
                    </span>
            </div>
          </div>
        </div>
        <TheHeader :show-org="false" :show-name="false"/>
      </div>
      <div class="session-activity">
        <div class="notch-centered"></div>
        <div class="learning_path"
             :class="{'fold': !showPath}">
          <div v-if="headerCollapsed"
               class="session-header-small d-flex justify-content-between w-100">
            <div class="d-flex flex-row align-items-center">
              <router-link :to="{name: 'Homepage'}" class="back-button bg-primary rounded-right">
                <inline-svg
                  width="25" height="25"
                  :src="require('../assets/images/icons/Icon_DropdownArrow_Down.svg')"/>
              </router-link>
              <div class="d-flex display-h6 ml-3">
                <div v-if="currentSession.resource_count > 0"
                     @click="loadResources"
                     class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Folder.svg')"/>
                          </span>
                  <span class="btn-text mx-2"
                        :data-sessionid="currentSession.id">
                            {{ $t("app.label.resource") }}
                          </span>
                </div>
                <div v-if="currentSession.badge_count > 0"
                     @click="loadBadges"
                     class="d-flex align-items-center btn-session-action
                             font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Badges.svg')"/>
                          </span>
                  <span class="btn-text mx-2">
                             {{ $t("app.label.badges") }} <span class="font-weight-bold mr-2">
                            {{ currentSession.activated_badge }}/{{ currentSession.badge_count }}
                            </span>
                          </span>
                </div>
                <div v-if="currentSession.has_leaderboard == 1"
                     @click="loadLeaderboards"
                     class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Leaderboard.svg')"/>
                          </span>
                  <span class="btn-text mx-2">
                            {{ $t("app.label.leaderboard") }}
                    </span>
                </div>
                <div v-if="currentSession.forum != null"
                     @click="loadForum"
                     class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Topic.svg')"/>
                          </span>
                  <span class="btn-text mx-2">
                              {{ $t("app.label.forum") }}
                      </span>
                  <span class="forum-notification font-weight-bold"
                        :class="{'active': forum.unreadedPostCount > 0}">
                      {{ forum.unreadedPostCount }}</span>
                </div>
                <div v-if="currentSession.user_can_view_stats"
                     @click="loadStats($event,'all')"
                     class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm mr-2">
                          <span class="icon">
                            <inline-svg
                              width="18" height="18"
                              :src="require('../assets/images/icons/Icon_Score.svg')"/>
                          </span>
                  <span class="btn-text mx-2">
                            {{ $t("app.label.stats") }}
                    </span>
                </div>
                <div @click="getHelp"
                     class="d-flex align-items-center btn-session-action
                          font-weight-light btn btn-outline-primary btn-xsm">
                          <span class="icon font-weight-bold px-2" style="font-size: 1.3rem ">
                            ?
                          </span>
                  <span class="btn-text mx-2">
                            {{ $t("app.label.help") }}
                    </span>
                </div>
              </div>
            </div>
            <TheHeader :show-org="false" :show-name="false"/>
          </div>
          <div class="path_header">
            <ProgressDonut :object="currentSession"
                           :check-dates="false"
                           :session="true"
                           :small="true" :overlay="true"
                           class="mx-3"/>
            <h2 class="font-weight-normal">{{ currentSession.name }}</h2>
          </div>
          <div class="courses" :set="order = 0">
            <p class="mx-5">{{ currentSession.description | str_limit(showDescription?10000:100) }}
              <button
              v-if="longDescription"
              class="font-weight-light btn btn-outline-primary btn-xsm position-relative"
              @click.stop="showDescription = !showDescription">
              {{ !showDescription ? $t('show.more'):$t('show.less') }}</button></p>
            <div class="course ml-6"
                 v-for="(courses,index) in coursesChapter"
                 :key="index">
              <h4 class="font-weight-light" v-if="courses[0].chapterName">
                {{ courses[0].chapterName }}
              </h4>
              <h6 v-if="courses[0].available && courses[0].chapterEndDate">
                {{ $t('app.activity.unlocked.until',
                [formatDateFull(courses[0].chapterEndDate)]) }}
              </h6>
              <h6 v-if="!courses[0].available
              && courses[0].notAvailableReason === 'chapterStartDate'
              && courses[0].chapterStartDate">
                {{ $t('app.activity.locked.until',
                [formatDateFull(courses[0].chapterStartDate)]) }}
              </h6>

              <Activity class="activity"
                   :class="activityClasses(course)"
                   v-for="(course,j) in courses"
                   :key="j"
                   :activity="course"
                   :stats-available="currentSession.user_can_view_stats"
                   :set="order = order+1" :order="order"></Activity>
            </div>
          </div>
        </div>
        <button  @click="displayLearningPath"
                 id="side-control" class="side-control">
          <inline-svg
            :class="{'fold':!showPath}"
            width="25" height="25"
            :src="require('../assets/images/icons/Icon_DropdownArrow_Down.svg')"/>
        </button>
        <div id="activity-player" class="w-100 d-flex h-100 justify-content-center px-2">
          <div :class="[isMobile ? 'h-100 w-100 player-container' :
            'py-10 vh-100 vw-100 player-container']"
               class="my-auto">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </main>
    <ResourcesCanvas :class="{'offcanvas-on': showResource}" @close="closeResources"/>
    <BadgesCanvas :class="{'offcanvas-on': showBadge}" @close="closeBadges"/>
    <LeaderboardsCanvas :class="{'offcanvas-on': showLeaderboards}" @close="closeLeaderboards"/>
    <HelpCanvas :class="{'offcanvas-on': showHelp}" @close="closeHelp"/>
    <ForumCanvas ref="forum" :class="{'offcanvas-on': showForum}" @close="closeForum"/>
    <StatsCanvas ref="stats" :class="{'offcanvas-on': showStats}" @close="closeStats"/>
  </div>
</template>

<script>
import store from '@/store';
import {
  FETCH_BADGES,
  FETCH_FORUMTHREADS,
  FETCH_LEADERBOARDS,
  FETCH_RESOURCES,
} from '@/store/actions.type';
import { mapGetters } from 'vuex';
import HelperMixin from '@/mixins/helperMixin';
import ResourcesCanvas from '@/components/canvas/ResourcesCanvas.vue';
import BadgesCanvas from '@/components/canvas/BadgesCanvas.vue';
import LeaderboardsCanvas from '@/components/canvas/LeaderboardsCanvas.vue';
import HelpCanvas from '@/components/canvas/HelpCanvas.vue';
import ForumCanvas from '@/components/canvas/ForumCanvas.vue';
import TheHeader from '@/views/TheHeader.vue';
import StatsCanvas from '@/components/canvas/StatsCanvas.vue';
import Activity from '@/components/ui/Activity.vue';

export default {
  name: 'SessionView',
  mixins: [HelperMixin],
  components: {
    Activity,
    ForumCanvas,
    ResourcesCanvas,
    BadgesCanvas,
    LeaderboardsCanvas,
    HelpCanvas,
    StatsCanvas,
    TheHeader,
  },
  data() {
    return {
      leaderboardsParams: {
        course: 'all',
        min: 1,
        max: 10,
      },
      forumId: store.getters.currentSession.forum,
      showDescription: false,
      longDescription: store.getters.currentSession.description
        && store.getters.currentSession.description.length > 100,
      showResource: false,
      showBadge: false,
      showLeaderboards: false,
      showHelp: false,
      showForum: false,
      showStats: false,
      showPath: true,
      headerCollapsed: true,
      toast: null,
    };
  },
  beforeMount() {
    this.setOrgCSS();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === 'Homepage') {
      this.animateCSS('.session-card-title', 'fadeOut').then(() => next());
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.currentSession.status === '0') {
      this.toast.goAway(0);
    }
    next();
  },
  mounted() {
    this.resize();
    this.$el.querySelector('.current').scrollIntoView();
    window.addEventListener('resize', this.resize);
    if (this.isMobile()) {
      setTimeout(() => { this.displayLearningPath(); }, 2000);
    }
  },
  computed: {
    courseWithLeaderboard() {
      return this.courses.filter((course) => course.leader_board !== null);
    },
    ...mapGetters(['currentSession', 'courses', 'organization', 'resources', 'coursesChapter', 'course', 'forum']),
    cssProps() {
      if (this.currentSession && this.currentSession.thumbnail) {
        if (this.isMobileOrTablet()) {
          return {
            backgroundImage: `url(${this.getObjectThumbnail('session',
              this.organization.id,
              this.currentSession.id,
              this.currentSession.thumbnail_vertical)})`,
          };
        }

        return {
          backgroundImage: `url(${this.getObjectThumbnail('session',
            this.organization.id,
            this.currentSession.id,
            this.currentSession.thumbnail)})`,
        };
      }

      if (this.organization.wallpaper) {
        return {
          backgroundImage: `url(${this.getOrganizationWallpaper(
            this.organization.id,
            this.isMobile(),
          )})`,
        };
      }
      return {
        // eslint-disable-next-line global-require
        backgroundImage: `url(${require('@/assets/images/background.jpg')})`,
      };
    },
    gradient() {
      if (this.currentSession && this.currentSession.thumbnail) {
        return this.currentSession.use_gradient_background;
      }
      if (this.organization.wallpaper) {
        return this.organization.useGradientBackground;
      }
      return true;
    },
  },
  methods: {
    onCourseClick(clickedCourse, type) {
      this.$Progress.hide();
      if (clickedCourse.available === true) {
        if (this.course !== -1 && clickedCourse.id !== this.course.id) {
          this.$router.push({
            name: 'CourseView',
            params: {
              sessionId: this.currentSession.id,
              courseId: clickedCourse.id,
              type,
              orgId: this.organization.id,
            },
          });
        }
      } else {
        let reason = '';
        switch (clickedCourse.notAvailableReason) {
          default: reason = ''; break;
          case 'chapterStartDate': reason = this.$t('app.activity.locked.chapterStartDate', [clickedCourse.chapterName, this.formatDateFull(clickedCourse.chapterStartDate)]); break;
          case 'chapterEndDate': reason = this.$t('app.activity.locked.chapterEndDate', [clickedCourse.chapterName, this.formatDateFull(clickedCourse.chapterEndDate)]); break;
          case 'chapterCompletion': reason = this.$t('app.activity.locked.chapterCompletion', [clickedCourse.notAvailableReasonInfo]); break;
          case 'glueCompletion': reason = this.$t('app.activity.locked.glueCompletion', [clickedCourse.notAvailableReasonInfo]); break;
          case 'restartRule': reason = this.$t('app.activity.locked.restartRule'); break;
        }
        this.$dialog.alert(reason, {
          backdropClose: true,
        });
      }
    },
    loadResources() {
      this.showLeaderboards = false;
      this.showForum = false;
      this.$refs.forum.showThread = false;
      this.$refs.forum.showThread = false;
      this.showBadge = false;
      this.showHelp = false;
      this.showStats = false;
      this.isLoading = true;
      store.dispatch(FETCH_RESOURCES).then(() => {
        this.showResource = true;
        this.isLoading = false;
        this.$Progress.finish();
      });
    },
    closeResources() {
      this.showResource = false;
    },
    loadBadges() {
      this.showLeaderboards = false;
      this.showForum = false;
      this.$refs.forum.showThread = false;
      this.showResource = false;
      this.showHelp = false;
      this.showStats = false;
      this.isLoading = true;
      store.dispatch(FETCH_BADGES, this.currentSession.id).then(() => {
        this.showBadge = true;
        this.isLoading = false;
        this.$Progress.finish();
      });
    },
    closeBadges() {
      this.showBadge = false;
    },
    loadLeaderboards() {
      this.showForum = false;
      this.$refs.forum.showThread = false;
      this.showBadge = false;
      this.showResource = false;
      this.showHelp = false;
      this.showStats = false;
      this.isLoading = true;
      this.leaderboardsParams.course = this.courseWithLeaderboard.length > 1
        ? 'all' : this.courseWithLeaderboard[0].id;
      store.dispatch(FETCH_LEADERBOARDS, this.leaderboardsParams).then(() => {
        this.showLeaderboards = true;
        this.isLoading = false;
        this.$Progress.finish();
      });
    },
    getHelp(e) {
      e.stopPropagation();
      this.showForum = false;
      this.showBadge = false;
      this.showResource = false;
      this.showLeaderboards = false;
      this.$refs.forum.showThread = false;
      this.showHelp = true;
    },
    closeLeaderboards() {
      this.showLeaderboards = false;
    },
    closeHelp() {
      this.showHelp = false;
    },
    loadForum() {
      this.showHelp = false;
      this.showBadge = false;
      this.showResource = false;
      this.showLeaderboards = false;
      this.showStats = false;
      this.isLoading = true;
      store.dispatch(FETCH_FORUMTHREADS, this.currentSession.forum).then(() => {
        this.showForum = true;
        this.isLoading = false;
        this.$Progress.finish();
      });
    },
    closeForum() {
      this.showForum = false;
    },
    loadStats(e, glue) {
      e.stopPropagation();
      this.showLeaderboards = false;
      this.showForum = false;
      this.$refs.forum.showThread = false;
      this.showResource = false;
      this.showHelp = false;
      this.showBadge = false;
      this.$refs.stats.load(glue);
      this.showStats = true;
    },
    closeStats() {
      this.showStats = false;
    },
    displayLearningPath() {
      this.showPath = !this.showPath;
    },
    activityClasses(course) {
      let classes = this.course.id !== course.id ? 'cursor-hand' : ' ';
      classes += course.available === false ? 'cursor-not-allowed' : '';
      classes += this.course.id === course.id ? 'current' : ' ';
      return classes;
    },
    resize() {
      this.headerCollapsed = window.innerWidth < 992;
    },
  },
};
</script>
<style scoped>
.side-control{
  background: var(--primary);
  width: 3rem;
  height: 100%;
  border-bottom-right-radius: 1rem;
  border-top-right-radius: 1rem;
  display: flex;
  border: none;
  box-shadow: 1px 1px 3px #000000d1;
}
.side-control svg{
 width: 2rem;
  margin: auto;
  transform: rotate(90deg);
  transition: transform 300ms;
}
.side-control .fold{
  transform: rotate(-90deg);
}
.side-control:hover{
  background-color: var(--primary-darker) !important;
  border-color: var(--primary-darker) !important;
  -webkit-box-shadow: 0 0 10px 0px var(--primary-darker) !important;
  box-shadow: 0 0 10px 0px var(--primary-darker) !important;
}

.session-activity{
  display: flex;
  height: 100% !important;
  padding-top: 6rem !important;
}
.session-header-big{
  display: flex;
}
.session-header-small{
  display: none !important;
}
@media screen and (max-width: 992px) {
  .session-header-big{
    display: none !important;
  }
  .session-header-small{
    display: flex !important;;
  }
  .session-activity{
    padding-top: 0 !important;
  }
  .learning_path{
    padding-top: 0;
  }
}
</style>
